var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShapeSectionDivider1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1920 365",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M539.5 1H0V365H1921V1H1384C1377 1 1361 1.5 1347 15C1332.6 30.2 1321 33.3333 1317 33H606C595 33 586.5 29.5 577.5 20C565.1 4.8 547 1 539.5 1Z",
    fill: "url(#paint0_linear_1326_383)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 1H539.5C547 1 565.1 4.8 577.5 20C586.5 29.5 595 33 606 33C614.8 33 1083.67 33 1317 33C1321 33.3333 1332.6 30.2 1347 15C1361 1.5 1377 1 1384 1C1389.6 1 1744.33 1 1921 1",
    stroke: "#322966",
    strokeOpacity: 0.8,
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1326_383",
    x1: 960.5,
    y1: 102.5,
    x2: 960.5,
    y2: 1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#070710"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.806277,
    stopColor: "#120C23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#22153D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShapeSectionDivider1);
export default __webpack_public_path__ + "static/media/shape_section_divider_1.f276d27e20781da90097b94ff96d87c9.svg";
export { ForwardRef as ReactComponent };